import { FC } from "react";
import { Box, Select, MenuItem, Tooltip } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { IBateriaVirtual, VirtualBatteryJoinTypes } from './types/virtualBattery';
import { useVirtualBatteries } from "./hooks/useVirtualBatteries";
import { useTranslation } from "react-i18next";

export interface IVirtualBatteryDiscountSelectProps {
  bateriaVirtual: IBateriaVirtual;
  readOnly?: boolean;
  tooltip?: string;
}

const VirtualBatteryDiscountSelect: FC<IVirtualBatteryDiscountSelectProps> = ({
  bateriaVirtual,
  readOnly = false,
  tooltip
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const { 
    virtualBatteryTypes,
    handleBatteryTypeChange,
  } = useVirtualBatteries();

  return (
    <Box>
      <Tooltip
        title={tooltip && t(tooltip)}
        placement="right"
        arrow
        disableFocusListener={!readOnly}
        disableHoverListener={!readOnly}
        disableTouchListener={!readOnly}
        slotProps={{
          popper: {
            modifiers: [{
              name: 'offset',
              options: {offset: [0, -5]}
            }]
          }
        }}
      >
        <Select
          disabled={readOnly}
          sx={{ 
            [theme.breakpoints.down("md")]: {
              width: '74vw'
            }
          }}
          value={bateriaVirtual.gestio_descomptes}
          onChange={(event) => {
            handleBatteryTypeChange(
              event.target.value as VirtualBatteryJoinTypes, 
              bateriaVirtual.id
            );
          }}
        >
          {virtualBatteryTypes?.map((p) => {
            return <MenuItem 
              key={p.name} 
              value={p.name}
            >
              {t(`common:text.solar_wallet.modes.${p.name}`)}
            </MenuItem>
          })}
        </Select>
      </Tooltip>
    </Box>
  );
};

export default VirtualBatteryDiscountSelect;
